import React from 'react'
import './Label.less'

const Label = (props: { title?: string; htmlFor?: string; children?: any }) => {
  const { title, children, ...restProps } = props
  return (
    <label className="Label" {...restProps}>
      {title}
      {children}
    </label>
  )
}

export default Label
